export default {
  UserPermissionAboveOrderValue: 'userPermissionAboveOrderValue',
  UserPermissionAboveSpecifiedValue: 'userPermissionAboveSpecifiedValue',
  UserInGroup: 'userInGroup',
}
